<template>
  <div class="app-layout">
    <!-- Mobile sidebar backdrop -->
    <div v-if="sidebarOpen && !isStandalonePage" class="app-layout__backdrop" @click="closeSidebar"></div>

    <Sidebar v-if="!isStandalonePage" v-bind:lang="showLang[selectLang]" v-bind:usLang="selectLang" v-bind:guideStepMenu="nextStepMenuStatus" v-bind:guideOpenTeachingAgain="openTeachingAgain" v-bind:getChangeLinkType="getChangeLinkType" v-bind:useFbCustomizeStatusForView="useFbCustomizeStatusForView" :sidebarOpen="sidebarOpen" @menuCheck="doMenuCheck" @firstLoginStatus="doFirstLoginStatus" @fbNum="transmitFbNum" @tiktokNum="transmitTiktokNum" @sidebarFbCustomize="doSidebarFbCustomize" @closeForTeaching="doCloseForTeaching" @loginSuccess="handleLoginSuccess" @closeSidebar="closeSidebar"/>
    <div class="app-layout__main">
      <!-- Mobile hamburger button -->
      <button v-if="!sidebarOpen && !isStandalonePage" class="app-layout__hamburger" @click="toggleSidebar">
        <i class="fas fa-bars"></i>
      </button>
      <router-view v-bind:newTeaching="newTeaching" v-bind:getFirstLoginStatus="getFirstLoginStatus" v-bind:getTransmitFbNum="getTransmitFbNum" v-bind:getTransmitTiktokNum="getTransmitTiktokNum" v-bind:useFbCustomize="useFbCustomize" v-bind:closeForTeaching="closeForTeaching" @childLang="useLang" @nextStep="nextStepMenu" @childHomeOpenFirstLogin="homeOpenFirstLogin" @childSetChangeLinkType="setChangeLinkType" @canUseFbCustomize="canUseFbCustomize" @toggleSidebar="toggleSidebar"/>
      <NewsPopup v-if="!isStandalonePage" ref="newsPopup" />
      <LineFloatButton v-if="!isStandalonePage" />
    </div>
  </div>
</template>

<script>
  import { createApp } from 'vue'
  import Sidebar from '@/components/Sidebar.vue'
  import NewsPopup from '@/components/NewsPopup.vue'
  import LineFloatButton from '@/components/LineFloatButton.vue'
  import lang from '@/language/lang.json'

  export default {
    components: {
      Sidebar,
      NewsPopup,
      LineFloatButton,
    },
    data() {
      return {
        sidebarOpen: false,
        selectLang: 'zh-TW',
        nextStepMenuStatus: -1,
        getFirstLoginStatus: [],
        getTransmitFbNum: 0,
        getTransmitTiktokNum: 0,
        getChangeLinkType: 'f',
        showLang: lang,
        newTeaching: 'false',
        openTeachingAgain: 'N',
        useFbCustomize: false,
        useFbCustomizeStatusForView: null,
        closeForTeaching: null,
      }
    },
    computed: {
      isStandalonePage() {
        return ['TrialBindCard', 'OnboardingLinkAccount'].includes(this.$route.name)
      }
    },
    methods: {
      toggleSidebar() {
        this.sidebarOpen = !this.sidebarOpen;
      },
      closeSidebar() {
        this.sidebarOpen = false;
      },
      useLang(v){
        this.selectLang = v
      },
      doMenuCheck(v){
        this.newTeaching = v;
      },
      doFirstLoginStatus(v){
        this.getFirstLoginStatus = v;
      },
      transmitFbNum(v){
        //console.log('transmitFbNum');
        //console.log(v);
        this.getTransmitFbNum = v;
      },
      transmitTiktokNum(v){
        //console.log('transmitTiktokNum');
        //console.log(v);
        this.getTransmitTiktokNum = v;
      },
      nextStepMenu(v) {
        // console.log('nextStepMenu');
        // console.log(v);
        // console.log('b nextStepMenuStatus');
        // console.log(this.nextStepMenuStatus);
        this.nextStepMenuStatus = v
        // console.log('a nextStepMenuStatus');
        // console.log(this.nextStepMenuStatus);
      },
      homeOpenFirstLogin(v){
        this.openTeachingAgain = v;
      },
      setChangeLinkType(v){
        //console.log('app setChangeLinkType');
        this.getChangeLinkType = v;
      },
      doSidebarFbCustomize(v){
        //console.log('doSidebarFbCustomize', v);
        this.useFbCustomize = v
      },
      canUseFbCustomize(v){
        //console.log('canUseFbCustomize', v);
        this.useFbCustomizeStatusForView = v;
      },
      doCloseForTeaching(){
        this.closeForTeaching = false;
      },
      handleLoginSuccess(){
        if (this.$refs.newsPopup) {
          this.$refs.newsPopup.checkLatestNews();
        }
      }
    }
  }
</script>

<style>
.app-layout {
  position: relative;
  min-height: 100vh;
  background-color: #e5e7eb;
}

@media (min-width: 1024px) {
  .app-layout {
    display: flex;
  }
}

.app-layout__main {
  min-height: 100vh;
  flex: 1;
  min-width: 0;
}

.app-layout__backdrop {
  position: fixed;
  inset: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
}

@media (min-width: 1024px) {
  .app-layout__backdrop {
    display: none;
  }
}

/* Mobile hamburger button */
.app-layout__hamburger {
  display: none;
}

@media (max-width: 1023px) {
  .app-layout__hamburger {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 25;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: var(--navy, #0f2b4a);
    color: #fff;
    border: none;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.2s;
  }

  .app-layout__hamburger:active {
    opacity: 0.7;
  }

  /* Push header content right to avoid hamburger overlap */
  .app-layout__main header {
    padding-left: 56px;
  }
}
</style>
